import { Injectable } from '@angular/core';
import { HttpRequestService } from './api/http-request.service';
import { environment } from '@environments/environment';
import { RequestResponse } from './api/interfaces/request.interface';
import { Observable, of } from 'rxjs';
import { transformJsonToFormData } from '@utilities/transform-json-to-form-data';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService extends HttpRequestService {

  private url = "auth";

  constructor() {
    super();
    this.getToken();
  }

  public postTokenClient(body: { username: string; password: string; }): Observable<RequestResponse>{
    const clientBody = {
      ...body,
      api_username: environment.api_username,
      api_password: environment.api_password
    }

    return this.postUser(`${this.url}/client/login`, clientBody);
  }

  public postSendOtp(body: {otp_type: number, user_id: number, session_code: string; }): Observable<RequestResponse>{
    return this.postUser(`${this.url}/client/login/otp`, body);
  }

  public postValidateOtp(body: {user_id: string; otp: string; session_code: string }): Observable<RequestResponse>{
    return this.postUser(`${this.url}/client/login/otp/validation`, body);
  }

  public saveToken(token: string){
    localStorage.setItem('token-logidec', token);
  }

  public getToken(): string | null {
    return localStorage.getItem('token-logidec');
  }

  public saveRefreshToken(token: string): void {
    localStorage.setItem('refresh-token', token);
  }

  public refreshToken(): Observable<RequestResponse>{
    const body = {
      user: localStorage.getItem('name'),
      token: this.getToken()
    }
    return this.postUser(`${this.url}/client/refresh`, body);
  }

  public cleanUpToken(){
    localStorage.removeItem('token-logidec');
  }

  public override logout(){
    localStorage.clear();
    this.router.navigate(['/auth/iniciar-sesion'])
  }

  userData: {initial: string, name: string} = {initial: '', name: ''};

  public set setUserData(data: {initial: string, name: string}){
    localStorage.setItem('initial', data.initial);
    localStorage.setItem('name', data.name);
  }

  public get getUserData(){
    this.userData = {initial: localStorage.getItem('initial') ?? '', name: localStorage.getItem('name') ?? ''}
    return this.userData;
  }

}
